import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import AuthenticatedNavigation from './AuthenticatedNavigation';
import { useAuth } from '../../hooks/useAuth';

const SiteHeader: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  return (
    <header className="bg-white border-b border-gray-200">
      {/* Top Utility Bar */}
      <div className="bg-gray-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-end items-center h-10 text-sm gap-x-2">
            {/* <a href="#demo" className="text-gray-700 hover:text-navy-700 ml-6">Schedule a Demo</a> */}
            <button
              onClick={() => navigate('/customer-service')}
              className="text-gray-700 hover:text-navy-700 ml-6"
            >
              Customer Service
            </button>
            <Link to="/broker/register" className="ml-6 text-primary-600 font-medium hover:text-primary-700">
              Partner Signup
            </Link>
            {isAuthenticated ? (
              <button 
                onClick={() => navigate('/dashboard')}
                className="ml-6 text-navy-700 font-medium hover:text-navy-900"
              >
                Dashboard
              </button>
            ) : (
              <button 
                onClick={() => navigate('/login')}
                className="ml-6 text-navy-700 font-medium hover:text-navy-900"
              >
                Login
              </button>
            )}
            {/* Additional resource links requested */}
            <Link to="/blog" className="ml-6 text-gray-700 hover:text-navy-700">Blog</Link>
            <Link to="/glossary" className="ml-6 text-gray-700 hover:text-navy-700">Glossary</Link>
            <Link to="/faq" className="ml-6 text-gray-700 hover:text-navy-700">FAQ</Link>
            <Link to="/customer-service" className="ml-6 text-gray-700 hover:text-navy-700">Help</Link>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          {/* Logo */}
          <AuthenticatedNavigation className="flex items-center cursor-pointer">
            <img src="/24lp-logo-primary.png" alt="Twenty Four Capital" className="h-20 w-auto" />
          </AuthenticatedNavigation>
          
          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="/#how-it-works" className="text-gray-700 hover:text-navy-700 font-medium">How it Works</a>
            <a href="/#platform-features" className="text-gray-700 hover:text-navy-700 font-medium">Platform Features</a>
            <a href="/#why-us" className="text-gray-700 hover:text-navy-700 font-medium">Why Choose Us</a>
          </div>

          {/* CTA Button */}
          <button 
            onClick={() => navigate('/check-eligibility')}
            className="bg-orange-500 text-white px-6 py-2.5 rounded-md font-medium hover:bg-orange-600 transition-colors"
          >
            Get Started
          </button>
        </div>
      </nav>
    </header>
  );
};

export default SiteHeader; 